import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  GET_LIST_CAMDO,
  POST_CAM_DO,
  GET_SOTAISANTHANHLY_CAMDO,
} from "actions/CamDo/actionTypes";
import {
  getListCamDoSuccess,
  getListCamDoFailure,
  getSoTaiSanThanhLyCamDoSuccess,
  getSoTaiSanThanhLyCamDoFailure,
  postCamDoSuccess,
  postCamDoFailure,
} from "actions/CamDo";
import CamDoApi from "service/camDoApi";
import { pushNotification } from "utils/notifications";

function* getListCamDo(action) {
  try {
    const response = yield call(CamDoApi.list, action.dataSearch);
    if (response.ok) {
      yield put(getListCamDoSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getListCamDoFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getListCamDoFailure());
  }
}

function* getSoTaiSanThanhLyCamDo(action) {
  try {
    const response = yield call(CamDoApi.SoTaiSanThanhLy, {});
    if (response.ok) {
      if (response.data.countTaiSan)
        yield put(getSoTaiSanThanhLyCamDoSuccess(response.data.countTaiSan));
      else yield put(getSoTaiSanThanhLyCamDoFailure());
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getSoTaiSanThanhLyCamDoFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getSoTaiSanThanhLyCamDoFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_CAMDO, getListCamDo);

  yield takeLatest(GET_SOTAISANTHANHLY_CAMDO, getSoTaiSanThanhLyCamDo);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
